import { getUserConfiguration } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export function isInboxPlusEnabled(): boolean {
    return (
        isInboxPlusDefaultTabsFlightEnabled() &&
        getUserConfiguration().UserOptions.InboxPlusTabs !== null
    );
}

export function isInboxPlusDefaultTabsFlightEnabled(): boolean {
    return isFeatureEnabled('tri-inbox-plus-v1') || isFeatureEnabled('tri-inboxPlusDefaultTabs');
}

export function isInInboxPlusDefaultTabsExperiment(): boolean {
    return (
        isFeatureEnabled('tri-inboxPlusDefaultTabs') ||
        isFeatureEnabled('tri-inboxPlusDefaultTabsControl')
    );
}
